import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { ApiResponse } from '../models/api-response';

export interface ValidateTokenResult {
  isValid: boolean;
  email?: string | null;
}

/** Self-service password recovery + set-password (token-based) endpoints. */
@Injectable({ providedIn: 'root' })
export class AccountRecoveryService {
  private baseUrl = `${environment.apiUrl}/Auth`;

  constructor(private http: HttpClient) {}

  forgotPassword(email: string): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(`${this.baseUrl}/ForgotPassword`, { email });
  }

  validateResetToken(token: string): Observable<ApiResponse<ValidateTokenResult>> {
    return this.http.get<ApiResponse<ValidateTokenResult>>(
      `${this.baseUrl}/ValidateResetToken?token=${encodeURIComponent(token)}`,
    );
  }

  setPassword(token: string, password: string): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(`${this.baseUrl}/SetPassword`, { token, password });
  }
}
